import type { RequestStatus } from "types/requests";
import type { ICalculatedTotals } from "types/totals";

export const RECEIVE_CALCULATED_TOTALS = "calculate_totals/RECEIVE";
export const APPLY_PROMO = "calculate_totals/APPLY_PROMO";

export interface IReceiveCalcTotals {
  type: typeof RECEIVE_CALCULATED_TOTALS;
  calculatedTotals: ICalculatedTotals;
}

export interface IApplyPromo {
  type: typeof APPLY_PROMO;
  promoCode: string;
  isValidated: boolean | null;
}

export interface ISetGiftCardRequest {
  type: string;
  status: RequestStatus;
}

export function applyPromo(
  promoCode: string,
  isValidated: boolean | null = null // null indicates validation is incomplete/unknown
): IApplyPromo {
  return {
    type: "calculate_totals/APPLY_PROMO",
    promoCode,
    isValidated,
  };
}

export function receiveCalculatedTotals(
  calculatedTotals: ICalculatedTotals
): IReceiveCalcTotals {
  return {
    type: RECEIVE_CALCULATED_TOTALS,
    calculatedTotals,
  };
}
